var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-full base-grid grid grid-cols-4 gap-6 mx-auto",class:[
    _vm.styles,
    !_vm.ignoreGridSizeUseWidthFull && 'px-4',
    _vm.getClassWithQuery('sm:grid-cols-8 md:grid-cols-12')
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }